"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddressesAptosOperation = void 0;
var common_aptos_utils_1 = require("@moralisweb3/common-aptos-utils");
var common_core_1 = require("@moralisweb3/common-core");
exports.getAddressesAptosOperation = {
    method: 'GET',
    name: 'getAddressesAptos',
    id: 'aptosStreamsGetAddresses',
    groupName: 'aptosStreams',
    urlPathParamNames: ['id'],
    urlSearchParamNames: ['cursor', 'limit'],
    urlPathPattern: '/streams/aptos/{id}/address',
    firstPageIndex: 0,
    getRequestUrlParams: getRequestUrlParams,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        id: request.id,
        limit: (0, common_core_1.maybe)(request.limit, String),
        cursor: request.cursor,
    };
}
function deserializeResponse(jsonResponse) {
    var _a;
    return {
        result: ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function (address) { return common_aptos_utils_1.AptosAddress.create(address.address); }),
        total: jsonResponse.total,
    };
}
function serializeRequest(request) {
    return {
        id: request.id,
        limit: request.limit,
        cursor: request.cursor,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        id: jsonRequest.id,
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
    };
}
//# sourceMappingURL=getAddressesAptosOperation.js.map